// Recovered compiled webpack factory 28634. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { f: () => r });
  var n = i(91225),
    s = i(39361);
  function r(t, e) {
    let i = t[t.length - 1];
    for (let r = 1; r <= e; r++) {
      let o = (0, n.q)(0, e, r);
      t.push((0, s.k)(i, 1, o));
    }
  }
}
